import common from "../common";
import context_ from "../modules/context";
import utilities_ from "../modules/utilities";

declare function require(module: string): unknown;
const context = require("../modules/context") as typeof context_;
const utilities = require("../modules/utilities") as typeof utilities_;
//const jsUtilities = require("../../js/jsUtilities") as any;

class PageService {
    public applyOutdatedContent(data: common.IHotEditableFormResponseData, editVue: common.IHotEditableFormVue | null) {
        const currentIsWidget = !!editVue?.shared && !!editVue.shared.getCurrentEmbeddedComponentName();
        const hasWidgetsToRefresh = !!data.outdatedContent?.hotEmbeddedComponentsToRefresh?.length;
        const entirePage = data.outdatedContent?.refreshEntirePage || (!currentIsWidget && !hasWidgetsToRefresh);
        const onApply = entirePage
            ? () => { utilities.refresh(); }
            : () => {
                if (editVue)
                    if (hasWidgetsToRefresh)
                        editVue.shared?.updateHotEmbeddedComponents(data.outdatedContent?.hotEmbeddedComponentsToRefresh);
                    else
                        editVue.shared?.updateCurrentHotEmbeddedComponent();
            };

        this.isInvalidResponseDataGlobal(data, onApply);
    }

    public isInvalidResponseDataGlobal(data?: common.IResponseDataGlobal, onRefreshApply?: () => void) {
        if (!data || !data.outdatedContent)
            return true;

        const t = data.outdatedContent.CustomRefreshTitleHtml;
        const m = data.outdatedContent.CustomRefreshMessageHtml;
        const p = context.components.getPage();

        p.showRefreshPopup(() => {
            if (onRefreshApply)
                onRefreshApply();
        }, t, m);

        return false;
    }
}

export = PageService;